export default __webpack_public_path__ + "static/media/clippers-city.748caf44.jpeg";